import {computed} from "mobx";
import {METADATA_FILTERS} from "../../../../../core/models/metatdata/metadata-filters.consts";
import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";

export class CompetitorMatchesPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    let title = this.staticTitle;

    if (this.titleSection) {
      title = this.titleSection.getElementValue(METADATA_FILTERS.COMPETITOR.matches)
    }

    return title
  }

  @computed get description(): String {
    let description = this.staticDescription;

    if (this.descriptionSection) {
      description = this.descriptionSection.getElementValue(METADATA_FILTERS.COMPETITOR.matches)
    }

    return description
  }

  get staticTitle() {
    const title = this.websiteTerms.COMPETITOR_MATCHES_TITLE_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName
    });

    return this.titleFormatTerm(title);
  }

  get staticDescription() {
    const description = this.websiteTerms.COMPETITOR_MATCHES_DESCRIPTION_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName
    });

    return this.descriptionFormatTerm(description);
  }

  get canonicalUrl(): String {
    const canonicalUrl: String = super.canonicalUrl.split('/').slice(0, -1).join('/');

    return canonicalUrl
  }
}